shadow$provide[377] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, default:{enumerable:true, get:function() {
  return $$default;
}}});
const $$default = `vec4 fragmentRGBA(vec4 rgba, vec4 stpq) {
  return rgba;
}`;

};